import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { header } from 'app/_misc/headers';
import { ILookupValues } from 'app/_models/ILookupValues';

@Injectable({ providedIn: 'root' })
export class ImportService {
  constructor(private httpClient: HttpClient) { }

  getModules() {
    return this.httpClient.get('/import/getmodules', { 
      headers: new header().JsonHeader, observe: 'response' 
    }).pipe(map(response => {        
      return response.body as ILookupValues[]; 
    }), catchError(this.handleError));
  } 

  importFile(formData: FormData) {
    return this.httpClient.post('/import/importfile', formData, { 
      headers: new header().FormHeader, observe: 'response' 
    }).pipe(map(response => { 
      return response.body; 
    }), catchError(this.handleError));
  }
  
  handleError(error: any) {
    return throwError(error);
  }
}